
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 12h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zM4 24h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4zm-6-6h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zM4 18h4v4H4zM26 0v2h-4V0H8v2H4V0H0v32h30V0h-4zm2 30H2V8h26v22z"}})])
          )
        }
      }
    